// extracted by mini-css-extract-plugin
module.exports = {"container":"_eV","video":"_eW","content":"_eX","contentContainer":"_eY","title":"_eZ","text":"_e0","button":"_e1"};